export function geocode(googleMaps, address) {
  const geocoder = new googleMaps.Geocoder();

  return new Promise((resolve, reject) => {
    geocoder.geocode({
      address,
    }, (result, status) => {
      if (status === googleMaps.GeocoderStatus.OK) {
        const rawlocation = result[0].geometry.location;
        const location = { lat: rawlocation.lat(), lon: rawlocation.lng() };
        resolve({ location, count: result.length });
      } else {
        reject(status);
      }
    });
  });
}

export function reverseGeocode(googleMaps, location) {
  const geocoder = new googleMaps.Geocoder();

  return new Promise((resolve, reject) => {
    geocoder.geocode({
      location,
    }, (result, status) => {
      if (status === googleMaps.GeocoderStatus.OK) {
        const address = result[0].formatted_address;
        resolve({ address, count: result.length });
      } else {
        reject(status);
      }
    });
  });
}



// WEBPACK FOOTER //
// ./utils/mapping/geocoders/googleMapsGeocoder.js